<template>
  <div class="right_count">
    <div class="incoming_photo_box">
      <div class="incoming_preview" ref="incoming_preview">
        <div class="videoBox" ref="videoBox" v-show="showVideo">
          <div
            :style="{ transform: 'scale(' + videoScreenScale + ')' }"
            class="videoPlayerInner"
            ref="videoPlayerInner"
          >
            <div class="close_btn">
              <a class="selfClose_btn" @click="closeBtn"></a>
            </div>
            <haiKangPlatformNew
              v-if="showVideo"
              :videoClose="videoClose"
              :videoInfo="videoInfo"
            />
          </div>
        </div>
        <img :src="preview_inOutImage" />
        <span v-if="customerId != 60" class="door_photo_txt"
          >{{ preview_gatePostCode }}（{{ preview_inOrOut }}）</span
        >
      </div>
      <div class="incoming_photo_list">
        <ul>
          <li
            v-for="(item, i) in incomingImgArr"
            @click="incomingImg_click(i)"
            :key="i"
          >
            <img
              :src="
                item.fixedInOutImage ? item.fixedInOutImage : item.inOutImage
              "
            />
            <span v-if="customerId != 60" class="door_photo_txt">
              {{ item.gatePostCode }}（{{
                item.inOrOut == 1 ? "进厂" : "出厂"
              }}）
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div style="margin: 20px 0px 10px">
      <door-title v-if="!seasonClearPart">
        {{ customerId === 83 ? "累计车辆进厂数量" : "今日累计车辆进厂数量" }}
      </door-title>
    </div>
    <div class="incoming_count_box" v-if="!seasonClearPart">
      <ul class="incoming_count_ul">
        <li
          class="incoming_count_li"
          v-for="(item, i) in incomingData"
          :key="i"
        >
          <span
            :class="{
              incoming_type: true,
              incoming_type_19: incomingData.length >= 4,
            }"
            >{{ item.type }}</span
          >
          <span class="incoming_num number">
            {{ item.num }}
            <i v-if="add_i[i] !== 0 && flag" class="add_i">+{{ add_i[i] }}</i>
          </span>
        </li>
      </ul>
    </div>
    <div class="incoming_count_season" v-else>
      <div class="count_box_wrap" v-for="(item,index) in seasonData" :key="index">
        <!-- <div class="count_box_month">{{ item.month }}</div> -->
        <div class="count_label">
          <div class="count_label_name">{{ item.month }}</div>
          <div class="count_label_num">{{item.total}}</div>
        </div>
        <div class="count_label" v-for="(inner,i) in item.income" :key="i">
          <div class="count_label_name">{{ inner.type }}</div>
          <div class="count_label_num">{{ inner.percent }}</div>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import doorTitle from "../../components/doorTitle";
import { mapState, mapGetters } from "vuex";
import haiKangPlatform from "@/modules/videoComponents/component/haiKangPlatform";
import haiKangPlatformNew from "@/modules/videoComponents/component/haiKangPlatform_new";
import moment from "moment";
import bottom_components_blueVue from "../../../bottomComponents/bottom_components_blue.vue";
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  name: "rightCount",
  components: { doorTitle, haiKangPlatform,haiKangPlatformNew },
  props: ["asyncClick", "leftInfo"],
  watch: {
    asyncClick: {
      handler(n, o) {
        if (n != o) {
          this.getCountData();
          this.getData();
        }
      },
      deep: true,
    },
    "$store.state.closeTransportVideo": {
      handler(val, oldVal) {
        this.closeBtn();
      },
      deep: true,
    },
    pingAnCarPhoto: {
      handler(newVal) {
        if (newVal && newVal.length) {
          if (this.customerId == 92) {
            this.getData();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      pageInfo: "rightCount.vue",
      computedName: "今日累计车辆进厂组件",
      customerId: this.$store.state.customerId,
      incomingData: [
        {
          vehicleEmissions: 0, //暂无作用
          num: 0,
          type: "",
        },
      ],
      flag: true,
      num_i: [], //用于存储上一状态的num
      add_i: [], //当前num和上一状态的差值
      preview_inOutImage: "",
      preview_gatePostCode: "",
      preview_inOrOut: "",
      incomingImgArr: [{ gatePostCode: "", inOutImage: "", inOrOut: 0 }], //1进厂，0出厂
      DOORSETINTERVAL: null,
      DOORSETINTERVAL2: null,
      videoClose: false,
      videoInfo: {},
      showVideo: false,
      closeTransportVideo: new Date().getTime(),
      seasonClearPart:bmeConfig.seasonClearPart,
      seasonData:[]
    };
  },
  computed: {
    ...mapState({
      cleanTransportIp: "cleanTransportIp",
      pingAnCarPhoto: "pingAnCarPhoto",
    }),
    ...mapGetters({ closeTransportVideo: "getCloseTransportVideo" }),
  },
  mounted() {
    this.getCountData();
    this.getData();
    if(this.seasonClearPart){
      this.getCleanInOutMonthData()
    }
  },
  methods: {
    closeBtn() {
      this.showVideo = false;
    },
    async getCleanInOutMonthData(){
      let url = this.cleanTransportIp + "/transport/material/weight/month";
      let res = await this.$apiUtils.get3(url, {customerId:this.customerId});
      if(res && res.length){
        this.seasonData = res
      }else{
        this.seasonData = [
          {
            month:'-',
            total:'-',
            income:[
              {
               type: "国VI", percent: "0%"
              },
              {
               type: "新能源", percent: "-"
              },
              {
               type: "管道或管状带式输送机", percent: "-"
              }
            ]
          },
          {
            month:'-',
            total:'-',
            income:[
              {
               type: "国VI", percent: "0%"
              },
              {
               type: "新能源", percent: "-"
              },
              {
               type: "管道或管状带式输送机", percent: "-"
              }
            ]
          },
          {
            month:'-',
            total:'-',
            income:[
              {
               type: "国VI", percent: "0%"
              },
              {
               type: "新能源", percent: "-"
              },
              {
               type: "管道或管状带式输送机", percent: "-"
              }
            ]
          }
        ]
      }
    },
    async getCountData() {
      setPageActive("清洁运输进出厂车辆统计展示功能","open",true)
      if (this.DOORSETINTERVAL) {
        clearTimeout(this.DOORSETINTERVAL);
      }
      let param = {};
      if (this.customerId === 22) {
        param = {
          startTime:
            moment(new Date().getTime()).format("YYYY-MM-DD") + " 00:00:00",
          endTime:
            moment(new Date().getTime()).format("YYYY-MM-DD") + " 23:59:59",
        };
      }
      if (this.customerId === 83) {
        param = {
          startTime: this.leftInfo.timeInfo[0],
          endTime: this.leftInfo.timeInfo[1],
        };
      }
      param.customerId = this.customerId;
      let url = this.cleanTransportIp + "/transport/inout_count";
      let res = await this.$apiUtils.get3(url, param);
      let tmpList = [];
      let countFlag = false;
      if (
        this.customerId !== 19 &&
        this.customerId !== 118 &&
        this.customerId !== 42&&
        this.customerId !== 156
      ) {
        res.forEach((item, index) => {
          tmpList[index] = item;
          if (
            this.customerId !== 58 &&
            this.customerId !== 89 &&
            this.customerId !== 59 &&
            item.vehicleEmissions == 5
          ) {
            tmpList[0] = item;
            countFlag = true;
          }
        });
      } else {
        tmpList = res;
      }
      if (this.customerId == 95 && countFlag) {
        // 去掉重复的国五数据
        tmpList.shift();
      }
      this.incomingData = tmpList;
      console.log("lzh", res, this.incomingData);
      this.flag = true;
      res.forEach((x, i) => {
        this.add_i[i] = Math.abs(x.num - (this.num_i[i] ? this.num_i[i] : 0));
      });
      setTimeout(() => {
        this.flag = false;
        this.num_i = [];
        res.forEach((x) => {
          this.num_i.push(x.num);
        });
      }, 2000);
      let that = this;
      that.DOORSETINTERVAL = setTimeout(() => {
        that.getCountData();
      }, 30000);
    },
    async getData() {
      if (this.DOORSETINTERVAL2) {
        clearTimeout(this.DOORSETINTERVAL2);
      }
      let url = this.cleanTransportIp + "/transport/gate_post_code_list";
      let param = {};
      if (this.customerId === 83) {
        param = {
          startTime: this.leftInfo.timeInfo[0],
          endTime: this.leftInfo.timeInfo[1],
        };
      }
      if (this.customerId === 54) {
        // 获取当前日期
        let today = new Date();

        // 获取前一天的日期
        let yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        param = {
          startTime:
            moment(new Date(yesterday)).format("YYYY-MM-DD") + " 00:00:00",
          endTime:
            moment(new Date(yesterday)).format("YYYY-MM-DD") + " 23:59:59",
        };
      }
      if (this.customerId === 42) {
        param = {
          endTime: moment(
            new Date(this.leftInfo.timeInfo[1]).getTime() - 30 * 60 * 1000
          ).format("YYYY-MM-DD HH:mm:ss"),
        };
      }
      param.customerId = this.customerId;
      let res = await this.$apiUtils.get3(url, param);
      if (this.customerId == 60) {
        res.forEach((item) => {
          if (item.gatePostCode && item.gatePostCode.indexOf("7") >= 0) {
            item.fixedInOutImage = "./static/images/common/8_door.png";
            item.videoIdx = "7";
          } else if (item.gatePostCode && item.gatePostCode.indexOf("8") >= 0) {
            item.fixedInOutImage = "./static/images/common/5_door.png";
            item.videoIdx = "8";
          } else if (item.gatePostCode && item.gatePostCode.indexOf("9") >= 0) {
            item.fixedInOutImage = "./static/images/common/6_door.png";
            item.videoIdx = "9";
          }
        });
      }

      this.incomingImgArr = res;
      if (this.customerId == 92) {
        this.incomingImgArr = [];
        this.pingAnCarPhoto.forEach((item) => {
          this.incomingImgArr.push({
            inOutImage: item.inoutImage,
          });
        });
        this.incomingImgArr.push(res[res.length - 1]);
      }
      this.incomingImg_click(0, true);
      let that = this;
      that.DOORSETINTERVAL2 = setTimeout(() => {
        that.getData();
      }, 30000);
    },
    initVideo(i, isAuto) {
      this.showVideo = true;

      this.$forceUpdate();
      this.$nextTick(() => {
        let w = $(this.$refs.incoming_preview).outerWidth();
        let h = $(this.$refs.incoming_preview).outerHeight();

        if (!w || !h) {
          this.showVideo = false;
          return;
        }

        $(this.$refs.videoBox).css("width", w);
        $(this.$refs.videoBox).css("height", h);

        if (this.incomingImgArr[i]["videoIdx"] == "7") {
          this.videoInfo = {
            nvrUsername: "25453119",
            nvrPassword: "JTXYMD0FYZAZmZKisgYX",
            channelId: "003a728413464045b95fa5f7995ba7cf",
            nvrIp: "10.30.1.13",
            isCleanTransport: true,
            w: w,
            h: h,
          };
        } else if (this.incomingImgArr[i]["videoIdx"] == "8") {
          this.videoInfo = {
            nvrUsername: "25453119",
            nvrPassword: "JTXYMD0FYZAZmZKisgYX",
            channelId: "e8ac2c4af8634685b479e6965d67e397",
            nvrIp: "10.30.1.13",
            isCleanTransport: true,
            w: w,
            h: h,
          };
        } else if (this.incomingImgArr[i]["videoIdx"] == "9") {
          this.videoInfo = {
            nvrUsername: "25453119",
            nvrPassword: "JTXYMD0FYZAZmZKisgYX",
            channelId: "cede6966bd13434c8e29ef12f62eabfc",
            nvrIp: "10.30.1.13",
            isCleanTransport: true,
            w: w,
            h: h,
          };
        }
      });
    },
    incomingImg_click(i, isAuto) {
      if (!this.incomingImgArr.length) return;

      if (this.initVideoTimer) {
        clearTimeout(this.initVideoTimer);
      }
      this.initVideoTimer = setTimeout(() => {
        this.preview_inOutImage = this.incomingImgArr[i].inOutImage;
        this.preview_gatePostCode = this.incomingImgArr[i].gatePostCode;
        this.preview_inOrOut =
          this.incomingImgArr[i].inOrOut == 1 ? "进厂" : "出厂";

        if (this.showVideo && this.customerId == 60) {
          if (isAuto) {
            return;
          }
          this.showVideo = false;
          this.$forceUpdate();
          this.$nextTick(() => {
            if (!isAuto) {
              this.initVideo(i);
            }
          });
        } else if (this.customerId == 60) {
          if (!isAuto) {
            this.initVideo(i);
          }
        }
      }, 1000);
    },
  },
  beforeUnmount() {},
  beforeRouteLeave() {
    this.showVideo = false;
  },
  unmounted() {
    clearTimeout(this.DOORSETINTERVAL);
    this.DOORSETINTERVAL = null;
    clearTimeout(this.DOORSETINTERVAL2);
    this.DOORSETINTERVAL2 = null;
  },
};
</script>

<style lang="scss" scoped="scoped">
.right_count {
  width: 100%;
  height: 100%;
  padding: 42px 30px 0px;

  .videoBox {
    position: absolute;
    top: -30px;
    left: 0px;

    .videoPlayerInner {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
    }

    .self_btn {
      background-image: url("img/btn.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
      border-radius: 2px;
      width: 90px;
      height: 45px;
      line-height: 40px;
      display: inline-block;
      cursor: pointer;
    }

    .close_btn {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 99;
    }

    .selfClose_btn {
      background-image: url("img/closeBtn.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
      border-radius: 2px;
      width: 90px;
      height: 45px;
      line-height: 40px;
      display: inline-block;
      cursor: pointer;
    }
  }

  .incoming_count_box {
    background: linear-gradient(
      315deg,
      rgba(108, 151, 255, 0.01) 0%,
      rgba(118, 154, 243, 0) 50%,
      rgba(58, 116, 255, 0) 100%
    );
    box-shadow: 0px 0px 30px 0px rgba(244, 196, 143, 0.19),
      0px 0px 2px 0px #f4c48f;
    border: 1px solid;

    .incoming_count_ul {
      height: 100%;
      display: flex;
      justify-content: space-around;

      .incoming_count_li {
        height: 100%;
        width: 100%;
        position: relative;
        vertical-align: bottom;
        text-align: center;
        justify-content: space-around;

        &:before {
          position: absolute;
          top: 2px;
          right: 2px;
          content: "";
          width: 2px;
          height: 69px;
          background: #f5f5f5;
        }

        &:last-of-type:before {
          width: 0;
        }

        .incoming_type {
          font-size: 44px;
          color: #00aeff;
        }

        .incoming_type_19 {
          font-size: 30px;
          color: #00aeff;
        }

        .incoming_num {
          margin-left: 30px;
          position: relative;
          font-style: oblique;
          height: 73px;
          font-size: 56px;
          color: #f5a623;
          line-height: 73px;
          text-shadow: 8px 8px 8px rgba(245, 166, 35, 0.32);

          .add_i {
            color: #00fcff;
            border: 1px solid #00fcff;
            padding: 0px 5px;
            position: absolute;
            top: 16px;
            right: -66px;
            font-family: initial;
            font-size: 22px;
            display: flex;
            height: 30px;
            align-items: center;
          }
        }

        .incoming_plus {
          position: absolute;
          top: 0;
          right: 50px;
          width: 44px;
          height: 27px;
          background: rgba(0, 38, 70, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 252, 255, 1);
          color: #00fcff;
        }
      }
    }
  }
  .incoming_count_season{
    display: flex;
    height:110px;
    .count_box_wrap{
      border: 2px solid rgba(160, 148, 134, 0.8);
      display: flex;
      height:100%;
      margin-right:15px;
      .count_box_month{
        width:76px;
        height:100%;
        line-height: 110px;
        text-align: center;
        font-size:20px;
        color:rgb(153, 245, 255);
        border-right: 2px solid rgba(160, 148, 134, 0.8);
      }
      .count_label{
        width:94px;
        border-right: 2px solid rgba(160, 148, 134, 0.8);
        .count_label_name{
          text-align: center;
          font-size:23px;
          line-height: 60px;
          color:rgb(153, 245, 255);
          border-bottom: 2px solid rgba(160, 148, 134, 0.8);
          // width: 100%;
          
        }
       
       
        .count_label_num{
          text-align: center;
          font-size:20px;
          line-height: 50px;
          color:#f5a623;
       
        }
        &:last-child{
          border-right: 0;
        }
      }
    }
  }
  .incoming_photo_box {
    width: 100%;
    height: 565px;
    display: flex;

    .door_photo_txt {
      position: absolute;
      left: 10px;
      top: 10px;
    }

    .incoming_preview {
      width: 70%;
      position: relative;
      box-shadow: 0px 8px 10px #333333 inset;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .incoming_photo_list {
      width: 30%;
      overflow: auto;

      ul {
        li {
          position: relative;
          cursor: pointer;
          height: 193px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
